// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// See ADDITIONAL-TERMS.md for the section 7(b) attribution requirement.
//
// Hearsay — 3-2-1-GO between the start arriving and the first card being dealt.
//
// Without it whoever happens to be looking at their screen gets a free head start, and in a game
// where the opening actor can put somebody out before they have had a turn that is not cosmetic.
// THE AUDIO CARRIES IT — players watch the table, not the numerals.
//
// setInterval, never rAF: a peer whose tab is backgrounded at the start must still arrive on time,
// and rAF does not fire there at all. Each peer counts locally from the start message, so they are
// in step to within one network hop.

export interface Countdown {
  cancel: () => void;
}

export function runCountdown(opts: {
  container: HTMLElement;
  sfx: (name: string) => void;
  onDone: () => void;
}): Countdown {
  const { container, sfx, onDone } = opts;
  let n = 3;
  let dead = false;

  container.innerHTML = `<div class="count" role="status" aria-live="assertive"><span>3</span></div>`;
  const span = container.querySelector('span')!;
  sfx('tick');

  const timer = setInterval(() => {
    if (dead) return;
    n--;
    if (n > 0) {
      span.textContent = String(n);
      span.classList.remove('pop');
      void span.offsetWidth;
      span.classList.add('pop');
      sfx('tick');
      return;
    }
    if (n === 0) {
      span.textContent = 'Order';
      span.classList.add('pop');
      sfx('go');
      return;
    }
    clearInterval(timer);
    if (!dead) onDone();
  }, 700);

  return {
    cancel: (): void => {
      dead = true;
      clearInterval(timer);
    },
  };
}
